/**
 * Simple helper for more functional-style programming that returns a function
 * that itself returns a specific value.
 */
export function functionReturning<T>(returnValue: T): () => T {
  return () => returnValue;
}
